module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page-wrapper profile"
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_vm._v("Live Stream Test")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "padding-bottom": "56.25%",
      "overflow": "hidden"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "title": "TONE video player",
      "src": "https://content.jwplatform.com/players/a074QrQx-c398nk2E.html",
      "width": "80%",
      "height": "80%",
      "frameborder": "0",
      "scrolling": "auto",
      "allowfullscreen": ""
    }
  })])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-19786ae6", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19786ae6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/LiveStreamTest.vue